/** Storyteller incidents (besides police raids, which have their own system).
 *  Metadata only — `sim/events.ts` applies each by id, keeping config pure. */

export interface IncidentDef {
  id: string;
  label: string;
  kind: 'good' | 'bad';
  blurb: string;
  weight: number;
  durationSec?: number;
}

export const INCIDENTS: IncidentDef[] = [
  {
    id: 'customer-rush',
    label: 'Customer Rush',
    kind: 'good',
    blurb: 'Word got around. Dealers move product fast — ×2 cash for a while.',
    weight: 3,
    durationSec: 30,
  },
  {
    id: 'fresh-batch',
    label: 'Fresh Batch',
    kind: 'good',
    blurb: 'The crew is dialed in. The whole chain runs faster for a bit.',
    weight: 2,
    durationSec: 28,
  },
  {
    id: 'rival-shakedown',
    label: 'Rival Shakedown',
    kind: 'bad',
    blurb: 'A rival crew muscled in and skimmed a cut of your product and cash.',
    weight: 2,
  },
  {
    id: 'inspection',
    label: 'Heat on the Block',
    kind: 'bad',
    blurb: 'Patrols are sniffing around. HEAT jumps.',
    weight: 2,
  },
  {
    id: 'bad-trip',
    label: 'Bad Trip',
    kind: 'bad',
    blurb: 'Someone sampled the supply. A colonist is down for a while.',
    weight: 2,
  },
  {
    id: 'morale-slump',
    label: 'Morale Slump',
    kind: 'bad',
    blurb: 'Long shifts are wearing on everyone. Crew-wide mood dip.',
    weight: 1,
    durationSec: 24,
  },
];

export function incidentById(id: string): IncidentDef | undefined {
  return INCIDENTS.find((e) => e.id === id);
}
